import * as React from "react";
import { default as ReactSelect } from "react-select";


interface ISelectOptions {
    value: any;
    label: any;
}

type OptionsLoader = () => Promise<ISelectOptions[]>;

function createOptionsLoader(fn: () => Promise<any>, labelKey = 'name', valueKey = 'name', extraKey = ''): OptionsLoader {
    return () => {
        return fn().then((json: any) => {
            return json.map((result: any) => ({
                value: result[valueKey],
                label: result[labelKey],
                extraKey: extraKey ? result[extraKey] : undefined
            }));
        });
    };
}

export class Select extends React.Component<any, { options: any[]; isLoading: boolean; }> {
    constructor(props: any) {
        super(props);

        this.state = {
            options: this.props.options || [],
            isLoading: !!this.props.loadOptions
        };

        if (this.props.loadOptions) {
            createOptionsLoader(this.props.loadOptions, 'name', 'id', this.props.extraKey)().then((options: any) => {
                this.setState({
                    options,
                    isLoading: false
                });
            });
        }
    }

    onChange = (option: any) => {
        if (this.props.multi) {
            return this.props.onChange(option.map((v: any) => {
                if (!!this.props.valueObject) {
                    return {id: v.value};
                }

                return v.value
            }));
        }

        if (!option) {
            return this.props.onChange(null);
        }

        if (this.props.returnObject) {
            return this.props.onChange(option);
        }

        return this.props.onChange(option.value);
    };

    getValue = () => {
        if (this.props.multi) {
            if (!this.props.value) {
                return [];
            }
            return this.state.options.filter((option: any) => {
                return this.props.value.filter((v: any) => {
                    if (!!this.props.valueObject) {
                        return v.id === option.value;
                    }

                    return v === option.value;
                }).length > 0;
            });
        }

        return this.state.options.find((v: any) => v.value === this.props.value);
    };

    render() {
        const { name, multi, placeholder, disabled = false } = this.props;

        return (
            <ReactSelect
                //classNamePrefix="react-select"
                //className="react-select-container"
                isMulti={multi}
                isClearable={true}
                isSearchable={true}
                isDisabled={disabled}
                isLoading={this.state.isLoading}
                value={this.getValue()}
                name={name}
                placeholder={placeholder}
                options={this.state.options}
                onChange={this.onChange}
                theme={(theme)=>({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary25: 'rgba(47,149,69,.25)',
                        primary50: 'rgba(47,149,69,.5)',
                        primary75: 'rgba(47,149,69,.75)',
                        primary: '#2F9545'
                        },
                    spacing: {
                        ...theme.spacing,
                        controlHeight: 48
                        }
                    })
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/fields/Select.tsx